import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import Home24Create from './Home24Create.vue'
declareVconsoleComponent('home24Create', Home24Create, 'home24:create');  